<template>
  <div class="mt-10">
    <h3>Blockchain Transactions</h3>
    <v-data-table
      title="Blockchain Transactions"
      :items="transaction.block_chain"
      :headers="headers"
    >
    </v-data-table>
  </div>
</template>

<script>
export default {
  props: ["transaction"],
  data() {
    return {
      headers: this.pairTableLabelWithValue({
        Name: "name",
        Value: "value",
        Confirmations: "number_of_confirmations",
        gasUsed: "gasUsed",
        StartedA: "initiated_at",
        ErroredAt: "errored_at",
        NbRetry: "retry_count",
        TrxHash: "hash",
      }),
    };
  },
};
</script>
